import React from "react";

import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useActionReport } from "../../Report/hooks/useAction";
import useStyles from "../Company/styles";

type ReportRow = {
  id?: number;
  name?: string;
  group?: string;
  templateType: "shipeezi_default" | "custom";
};

const MilitaryTab = () => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { getAllReportGroup } = useActionReport();
  const { data: reportGroupsData, isFetching: loading } = getAllReportGroup();

  const reportsList: ReportRow[] = React.useMemo(() => {
    if (!reportGroupsData || !Array.isArray(reportGroupsData)) return [];
    const list: ReportRow[] = [];
    reportGroupsData.forEach((group: { group?: string; reports?: Array<{ id?: number; name?: string }> }) => {
      (group.reports || []).forEach((report) => {
        list.push({
          id: report.id,
          name: report.name,
          group: group.group,
          templateType: "shipeezi_default",
        });
      });
    });
    return list;
  }, [reportGroupsData]);

  return (
    <Grid container direction="row" className={classes.generalWrapper}>
      <Grid item xs={12}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
          {translate("reports", { defaultValue: "Reports" })}
        </h2>
        <p style={{ marginBottom: 16 }}>
          {translate("militaryReportsDescription", {
            defaultValue:
              "List of all available reports in the system and whether each uses the Shipeezi Default template or a client-provided custom template.",
          })}
        </p>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{translate("reportName", { defaultValue: "Report Name" })}</TableCell>
                <TableCell>{translate("group", { defaultValue: "Group" })}</TableCell>
                <TableCell>{translate("template", { defaultValue: "Template" })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3}>{translate("loading", { defaultValue: "Loading..." })}</TableCell>
                </TableRow>
              ) : reportsList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3}>{translate("noReports", { defaultValue: "No reports available." })}</TableCell>
                </TableRow>
              ) : (
                reportsList.map((row) => (
                  <TableRow key={row.id || row.name || Math.random()}>
                    <TableCell>{row.name || "—"}</TableCell>
                    <TableCell>{row.group || "—"}</TableCell>
                    <TableCell>
                      {row.templateType === "custom"
                        ? translate("customTemplate", { defaultValue: "Client-provided custom template" })
                        : translate("shipeeziDefaultTemplate", { defaultValue: "Shipeezi Default" })}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default MilitaryTab;
